$(document).ready(function() {
	if(!document.querySelector('.GPC0163')) return false;
	var screen = {
			// 페이지 전역변수
			val : {
				selectorTemplate : $('#selectorResultTemplate').clone().html()  // selector 모델 탬플릿
				, popularTemplate : $('#selectorPopularTemplate').clone().html()  // 추천 모델 탬플릿
				, selectorPage : 0 // selector 모델 페이지 (0, 3, 12 ==> 3개, 9개, 9개 조회)
				, totalCount : 0 // selector 모델 갯수
				, strickOption : {// 페이지 Strick 옵션 (추천제품)
					infinite: false,
					slidesToShow: 4,
					slidesToScroll: 4,
					arrows : true,
					dots: true,
					listStyle: true, 
					responsive: [{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							arrows : true
						}
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							arrows : false
						}
					}],
					prevArrow: carouselOptions.bigAnglePrev, // common.js variable
					nextArrow: carouselOptions.bigAngleNext // common.js variable
					}
			},
			// 페이지 함수
			func : {
				// 셀렉터 옵션 변경 이미지, 이미지Text 변경 flag
				setSelectorOptionDisplay : function(mode, imgUrl, imgDesc) {
					var $defaultImgArea = $(".selector-choice-view").find(".default") // 기본 이미지 에리어 (이미지)
		    		var $optionImgArea = $(".selector-choice-view").find(".view-act") // 셀렉터 옵션 이미지 에리어 (이미지 + 이미지 텍스트)
		    		var defalutImgUrl = $(".selector-choice-view").find(".default").attr("src") // 기본 이미지 URL
		    		if (mode == 'default') {
		    			if($defaultImgArea.hasClass("d-none")) {
		    				$defaultImgArea.removeClass("d-none");
		    			}
		    			if(!$optionImgArea.hasClass("d-none")) {
		    				$optionImgArea.addClass("d-none");
		    			}
		    		} else {
		    			if(!$defaultImgArea.hasClass("d-none")) {
		    				$defaultImgArea.addClass("d-none");
		    			}
		    			if($optionImgArea.hasClass("d-none")) {
		    				$optionImgArea.removeClass("d-none");
		    			}
		    			if(!isEmpty(imgUrl) && !isEmpty(imgDesc)) { // 둘 다 있는 경우
	    	    			$optionImgArea.find(".selector-option-Img").attr("src", imgUrl)
	    	    			$optionImgArea.find(".selector-option-desc").text(imgDesc)
	    				} else if (isEmpty(imgUrl) && !isEmpty(imgDesc)) { // bodyCopy 만
	    	    			$optionImgArea.find(".selector-option-Img").attr("src", defalutImgUrl)
	    	    			$optionImgArea.find(".selector-option-desc").text(imgDesc)
	    				} else if (!isEmpty(imgUrl) && isEmpty(imgDesc)) { // Img만
	    	    			$optionImgArea.find(".selector-option-Img").attr("src", imgUrl)
	    	    			$optionImgArea.find(".selector-option-desc").text(imgDesc)
	    				} else if (isEmpty(imgUrl) && isEmpty(imgDesc)) { // 둘 다 없는 경우
	    					$optionImgArea.find(".selector-option-Img").attr("src", defalutImgUrl)
	    	    			$optionImgArea.find(".selector-option-desc").text("")
	    				}
		    		}
				},
				
				// selector Option 하위 옵션 초기화
				clearSelectorOption : function(selectorIdx) {
					var subjectCnt = Number($("input[name='subjectCnt']").val())  
					for(var i=1; i<= Number(subjectCnt); i++) { // 하위 optionLevel 초기화
		    			var $optionDeleteSubject =  $("select[name='optionId'][data-selector-idx='"+String(i)+"']")
		    			if(i < Number(selectorIdx)) {continue;}
		    			if(i == Number(selectorIdx)) {continue;}
		    			if(i > Number(selectorIdx)) {
		    				$optionDeleteSubject.find("option:not(:first-child)").remove();
		    				$optionDeleteSubject.trigger('chosen:updated');
		    			} 
		    		}
				},
				
				// 모델리스트 추가
				setModelList : function (modelList, productMessages, mode) {
			    	var html = [];
					var hasMemberFlag = 'N'; 
					var ynProductTag = "N";
					var ynBrandTag = "N";
					var ynSibling = "N";
					var ynEnergyLabel = "N";
					var ynPrice = "N";
					var ynReviewRating = "N";
					var priceAreaYn = ""
					var promotionAreaYn = ""
					var limitSaleAreaYn = ""
					var emiMsgAreaYn = ""
					var buyNowUseFlag = $("input[name='buyNowUseFlag']").val();
					var labelUseFlag = $("input[name='labelUseFlag']").val();
					var obsLoginFlag = $("input[name='obsLoginFlag']").val();
					var useLabelIcon = $("input[name='useLabelIcon']").val();
					var emiUseFlag = $("input[name='emiUseFlag']").val();
					var limitSaleUseFlag = $("input[name='limitSaleUseFlag']").val();
					var obsCalculatorUseFlag = $("input[name='obsCalculatorUseFlag']").val();
					var currencyPosition = $("input[name='currencyPosition']").val();
					var reStockFuncFlag = $("input[name='reStockFuncFlag']").val();
					var obsBuynowFlag = $("input[name='obsBuynowFlag'").val();
					var bizType = $("input[name='bizType'").val();
					var btnAreaYn = ""
					var plpVipCheck = "";
					plpVipCheck = "false";
						
					//LGEFR-640 Start
					var repairModelAreaYn = "";
					//LGEFR-640 End
					for (var i = 0; i < modelList.length; i++) {
						var p = modelList[i]
						var template = mode == "selector" ? screen.val.selectorTemplate : screen.val.popularTemplate;
						priceAreaYn = p.priceAreaYn
						promotionAreaYn = p.promotionAreaYn
						limitSaleAreaYn = p.limitSaleAreaYn
						btnAreaYn = p.btnAreaYn
						emiMsgAreaYn = p.emiMsgAreaYn
						//LEGFR-640 Start
						repairModelAreaYn = p.repairModelAreaYn;
						//LEGFR-640 End
						// LGCOMPL-46 Start
						var currencyPosition = $('.GPC0163').find('input[name=currencyPosition]').val()
						var currencySymbol = $('.GPC0163').find('input[name=currencySymbol]').val()
						var obsConvertSubscriptionMonthlyCostArea = '';
						var obsConvertSubscriptionMonthlyCost = changeFormatFullPrice(p.obsConvertSubscriptionMonthlyCost, p.obsConvertSubscriptionMonthlyCostCent)
						if(p.obsConvertSubscriptionMonthlyCost != null && obsConvertSubscriptionMonthlyCost != '0') {
							if(currencyPosition != null) {
								obsConvertSubscriptionMonthlyCostArea = currencyPosition == 'R' ? obsConvertSubscriptionMonthlyCost + "" + currencySymbol
																	:	currencyPosition == 'L' ? currencySymbol + "" + obsConvertSubscriptionMonthlyCost
																	: '';
								}
						}
						// LGCOMPL-46 End
						var externalLinkTarget = '';
						if(p.externalLinkTarget != null && p.externalLinkTarget != ""){
							externalLinkTarget = p.externalLinkTarget.toLowerCase();
						}
							template = template.replace(/\*modelId\*/g, p.modelId)
											.replace(/\*modelName\*/g, p.modelName)
											.replace(/\*modelName_toLowerCase\*/g, p.modelName.toLowerCase())
											.replace(/\*imageAltText\*/g, (p.imageAltText != null) ? p.imageAltText : '')
											.replace(/\*userFriendlyName\*/g, p.userFriendlyName == null ? '' : p.userFriendlyName.replace(/\"/g, "''"))
											.replace(/\*salesModelCode\*/g, p.salesModelCode)
											.replace(/\*modelUrlPath\*/g, p.modelUrlPath)
											.replace(/\*mediumImageAddr\*/g, p.mediumImageAddr)
											.replace(/\*smallImageAddr\*/g, p.smallImageAddr)
											.replace(/\*reviewRatingStar2\*/g, p.reviewRatingStar2)
											.replace(/\*reviewRating\*/g, p.reviewRating)
											.replace(/\*reviewRatingPercent\*/g, p.reviewRatingPercent)
											.replace(/\*salesSuffixCode\*/g, (p.salesSuffixCode || ''))
											.replace(/\*wishTotalCnt\*/g, p.wishTotalCnt)
											.replace(/\*pdFav\*/g, p.myWishCnt == 'Y' ? 'pd-fav on' : 'pd-fav')
											.replace(/\*icoFav\*/g, p.myWishCnt == 'Y' ? 'ico-fav on' : 'ico-fav')
											.replace(/\*ariaChecked\*/g, p.myWishCnt == 'Y' ? 'true' : 'false')
											.replace(/\*modelCopyUrl\*/g, p.modelUrlPath)
											.replace(/\*obsLeadTimeMin\*/g, p.obsLeadTimeMin) 
											.replace(/\*obsLeadTimeMax\*/g, p.obsLeadTimeMax) 
											.replace(/\*promotionTextView\*/g, p.promotionTagTextFlag == 'Y' && plpVipCheck == "false" ? 'd-none' : '')
											.replace(/\*promotionTagTextView\*/g, (p.promotionTagTextFlag == 'Y' && plpVipCheck == "true") || p.promotionTagTextFlag != 'Y' ? 'd-none' : '') 
											.replace(/\*promotionLinkUrl\*/g, p.promotionLinkUrl ? p.promotionLinkUrl : "")
											.replace(/\*externalLinkTarget\*/g, externalLinkTarget == 'self' ? '_self' : '_blank')
											if(p.promotionLinkUrl) {
												template = template.replace(/\*promotionText\*/g, p.promotionText ? p.promotionText : "")
																   .replace(/\*promotionText2\*/g, "")
											} else {
												template = template.replace(/\*promotionText2\*/g, p.promotionText ? p.promotionText : "")
											}
							template = template.replace(/\*promotionTagTextFlag\*/g, p.promotionTagTextFlag)
											.replace(/\*promotionTagText\*/g, p.promotionTagText)
											// LGCOMPL-46 Start
											.replace(/\*obsSubscriptionLandingPageUrl\*/g, p.obsSubscriptionLandingPageUrl != null ? p.obsSubscriptionLandingPageUrl : '')
											.replace(/\*obsSubscriptionCtaLinkTarget\*/g, p.obsSubscriptionCtaLinkTarget != null ? p.obsSubscriptionCtaLinkTarget : '')
											.replace(/\*obsSubscriptionDisclaimer\*/g, p.obsSubscriptionDisclaimer != null ? p.obsSubscriptionDisclaimer : '')
											.replace(/\*obsConvertSubscriptionMonthlyCostArea\*/g, obsConvertSubscriptionMonthlyCostArea != '' ? obsConvertSubscriptionMonthlyCostArea : '')
											.replace(/\*obsSubscriptionMaxMonth\*/g, p.obsSubscriptionMaxMonth != null ? p.obsSubscriptionMaxMonth : '')
											// LGCOMPL-46 End
											;
							
							//LGEFR-640 Start
                            var repairabilityArea = $(template).find('.repairability-index');
                            var repairabilityMsg = repairabilityArea.attr('data-repairability-msg');
                            var targetBlankMsg = repairabilityArea.attr('data-target-blank-msg');
                            
                            if (repairModelAreaYn == "Y") {
                                if(p.labelRepairMap.length > 0){    
                                    var repairMapData = p.labelRepairMap[0];
                                    
                                    var repairAbilityHtml  = "<div class='score'>";
                                        repairAbilityHtml  += "<span class='txt'>"+repairabilityMsg+"</span>";
                                    if(repairMapData.linkUrl != 'null' && repairMapData.linkUrl != ''){
                                        repairAbilityHtml  += "<a href='"+repairMapData.linkUrl+"'";
                                        if(repairMapData.linkOpt =='S'){
                                            repairAbilityHtml  += " target='_self'";
                                        }else if(repairMapData.linkOpt =='B'){
                                            repairAbilityHtml  += " target='_blank'";
                                        }
                                        repairAbilityHtml  += " title='"+targetBlankMsg+"' class='link-pdf'>";
                                    } else {
                                        repairAbilityHtml += "<span class='link-pdf'>";
                                    }
                                    
                                    if(repairMapData.imagePathAddr != 'null' && repairMapData.imagePathAddr != ''){
                                        repairAbilityHtml  += "<img src='"+repairMapData.imagePathAddr+"' alt='"+repairMapData.altText+"'/>";
                                    }
                                    if(repairMapData.linkUrl != 'null' && repairMapData.linkUrl != ''){
                                        repairAbilityHtml  += "</a></div>";
                                    } else {
                                        repairAbilityHtml  += "</span></div>";
                                    }
                                    template = template.replace(/\*repairabilityIndex\*/g, repairAbilityHtml);
                                }else{
                                    template = template.replace(/\*repairabilityIndex\*/g, "");
                                }
                            } else {
                                template = template.replace(/\*repairabilityIndex\*/g, "");
                            }
                            //LGEFR-640 End
							
                            //LGCOMMON-12724 Start
							//LGCOMMON-7821 Start
							var epsPictoFlag = p.epsPictoFlag;
							var includeChargerYn = p.includeChargerYn  == 'Y' ? '' : 'not-included';
							var usbPdYn = p.usbPdYn == 'Y' ? 'USB PD' : '';
							var minPower = p.minPower;
							var maxPower = p.maxPower;
							var epsPictogramHtml = "";
							
							if(epsPictoFlag == "Y"){
								epsPictogramHtml += '<div class="c-charging-device">';
								epsPictogramHtml += '<div class="c-info-charging">';
								epsPictogramHtml += '<i class="c-info-charging__icon ' + includeChargerYn + '" aria-hidden="true">';
								epsPictogramHtml += '<span class="c-info-charging__alt">';
								epsPictogramHtml += '<strong>' + minPower + ' - ' + maxPower + ' W</strong> ' + usbPdYn;
								epsPictogramHtml += '</span>';
								epsPictogramHtml += '</i>';
								epsPictogramHtml += '<div class="c-info-charging__text">';
								epsPictogramHtml += '<strong>' + minPower + ' - ' + maxPower + ' W</strong> ' + usbPdYn;
								epsPictogramHtml += '</div>';
								epsPictogramHtml += '</div>';
								epsPictogramHtml += '</div>';
							}
							template = template.replace(/\*epsPictogramArea\*/g, epsPictogramHtml);
							//LGCOMMON-7821 End		
							//LGCOMMON-12724 End
							
							var $template = $(template)
							// selector 영역
							
							//LGEFR-640 Start
							if (repairModelAreaYn != "Y") {
                                $template.find(".repairability-index").remove();
                            }
							//LGEFR-640 End
							if(mode == 'selector') {
									
								var $selectorTag = $template.find(".tag-grade")
								var $selectorTagP = $template.find(".tag-grade p") 
								var $selectorTagSpan = $template.find(".tag-grade p span")
								var selectorTagUseChk = ''
								var selectorTagText = ''
								if(screen.val.selectorPage == 0) {
									if(i == 0) {
										selectorTagUseChk = $("input[name='recommendedTag1UseFlag']").val();
										if(selectorTagUseChk == 'Y') {
											selectorTagText = $("input[name='recommendedTag1']").val();
											$selectorTagSpan.text(selectorTagText)
											$selectorTagP.addClass("tag-imp")
										} else {
											$selectorTag.remove()
										}
			 						} else if (i == 1) {
			 							selectorTagUseChk = $("input[name='recommendedTag2UseFlag']").val();
										if(selectorTagUseChk == 'Y') {
											selectorTagText = $("input[name='recommendedTag2']").val();
											$selectorTagSpan.text(selectorTagText)
										} else {
											$selectorTag.remove()
										}
			 						} else if (i == 2) {
			 							selectorTagUseChk = $("input[name='recommendedTag3UseFlag']").val();
										if(selectorTagUseChk == 'Y') {
											selectorTagText = $("input[name='recommendedTag3']").val();
											$selectorTagSpan.text(selectorTagText)
										} else {
											$selectorTag.remove()
										}
				 					}
								} else {
									$selectorTag.remove();
								}
							}
							// selector 영역
							
							var title = $("#openTarget").val();
							p.obsMembershipLinkTarget == '_blank' ? title : title = "";
							
							var $keyBlocks = $template.find('*[data-key]')
							
							var pdrCompareUseFlag = p.pdrCompareUseFlag;
							if(pdrCompareUseFlag == 'N'){
								$template.find('.js-compare').remove();
							}

							for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
								var $currentKeyBlock = $keyBlocks.eq(i1),
									key = $currentKeyBlock.get(0).getAttribute('data-key'),
									val = p[key];
								if(!val || (val == null || val == "N")) {
									if($currentKeyBlock.is('.btn')) {
									}else {
										var countryCode = $('[data-countrycode]').attr('data-countrycode');
											if((p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y') || (p.obsPreOrderFlag == "Y" || p.obsPreOrderRSAFlag == "Y")){
												$keyBlocks.closest('p').addClass('tag-imp');
												if(p.vipPriceFlag != 'Y' && p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y') {
													$template.find('.price-vip').text(p.limitSaleTitle);
												} 
											}
											
											if($template.find('.model-buy').length > 0 && (p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y')){
												if($template.find('.only-price').length > 0){
													$template.find('.model-buy').removeClass('only-price');	
												}
											}
										if((key == 'productTag1' ||  key == 'productTag2')) {
											$currentKeyBlock.closest('p').remove();
										}else{
											$currentKeyBlock.remove();
										}
									}
								}else {
									if($currentKeyBlock.is('.btn')) {
										$currentKeyBlock.addClass('active');
									}else{
											if(p.limitSaleUseFlag == 'Y'){
												if(p.obsLimitSale == 'Y'){
													$keyBlocks.closest('p').addClass('tag-imp');
													if(p.vipPriceFlag != 'Y') {
														$template.find('.price-vip').text(p.limitSaleTitle);
													}
												}
												
												if($template.find('.model-buy').length > 0){
													if($template.find('.only-price').length > 0){
														$template.find('.model-buy').removeClass('only-price');	
													}
												}
											}
									}
								}

							}

							// in-house reivew rating star - ie fix
							$template.find('.rating:not(.siblingModelTotal) .carmine-star').css({
								width: p.reviewRatingPercent+"%"
							});
							
							// sibling target check
							if(p.target && p.target.toUpperCase() == "SELF") {
								$template.find('.item.js-model').addClass('self');
							}else {
								$template.find('.item.js-model').removeClass('self');
							}
							
							if(labelUseFlag == "Y" && useLabelIcon == "Y") {
								if(mode == 'selector') {
								
									var $labelList = $template.find('.label-list .label-inner ul');
									var labelAward = $labelList.find('template[data-label-type="AWARD"]').clone().html();
									var labelFeature = $labelList.find('template[data-label-type="FEATURE"]').clone().html();
									var labelDelivery = $labelList.find('template[data-label-type="DELIVERY"]').clone().html();
									var labelDeliveryPeriod = $labelList.find('template[data-label-type="DELIVERYPERIOD"]').clone().html(); 
									var labelWarranty = $labelList.find('template[data-label-type="WARRANTY"]').clone().html();
									var labelBullet = $labelList.find('template[data-label-type="BULLET"]').clone().html();
									var labelShippingFlag = $labelList.find('template[data-label-type="SHIPPINGFLAG"]').clone().html();
									var labelDeliveryFlag = $labelList.find('template[data-label-type="DELIVERYFLAG"]').clone().html();
									var labelInstallationFlag = $labelList.find('template[data-label-type="INSTALLATIONFLAG"]').clone().html();
									var keyfeatureFlag = $labelList.find('template[data-label-type="KEYFEATUREFLAG"]').clone().html(); 
									var labelIconMap = p.labelIconMap;
									for(var cnt = 0; cnt < labelIconMap.length; cnt++) {
										var tmpLabelAward = labelAward;
										var tmpLabelFeature = labelFeature;
										var tmpLabelDelivery = labelDelivery;
										var tmpLabelDeliveryPeriod = labelDeliveryPeriod; 
										var tmpLabelWarranty = labelWarranty;
										var tmpLabelBullet = labelBullet;
										var tmpLabelShippingFlag = labelShippingFlag;
										var tmpLabelDeliveryFlag = labelDeliveryFlag;
										var tmpLabelInstallationFlag = labelInstallationFlag;
										var tmpLabelKeyfeatureFlag = keyfeatureFlag; 
										var tmpText = "";
										if(labelIconMap[cnt].shortDescType == 'AWARD' || labelIconMap[cnt].shortDescType == 'FEATURE') {
											if(labelIconMap[cnt].cssFontBold=="Y" && labelIconMap[cnt].cssFontItalic=="Y") {
												tmpText = "<li data-adobe-tracking-wish='Y' data-page-event='plp_labelicon' class='text-all'>";
											} else if(labelIconMap[cnt].cssFontBold=="Y") {
												tmpText = "<li data-adobe-tracking-wish='Y' data-page-event='plp_labelicon' class='text-bold'>";
											} else if(labelIconMap[cnt].cssFontItalic=="Y") {
												tmpText = "<li data-adobe-tracking-wish='Y' data-page-event='plp_labelicon' class='text-italic'>";
											} else {
												tmpText = "<li data-adobe-tracking-wish='Y' data-page-event='plp_labelicon'>";
											}
											if(labelIconMap[cnt].linkUrl != null && labelIconMap[cnt].linkUrl != '') {
												tmpText = tmpText + "<a href='" +  labelIconMap[cnt].linkUrl + "' ";
												if(labelIconMap[cnt].linkOpt == "S") {
													tmpText = tmpText + "target='_self' data-adobe-tracking-wish='Y' data-page-event='plp-labelicon'>";
												} else if(labelIconMap[cnt].linkOpt == "B") {
													tmpText = tmpText + "target='_blank' data-adobe-tracking-wish='Y' data-page-event='plp-labelicon'>";
												}
											}
											if(labelIconMap[cnt].imagePathAddr != '' && labelIconMap[cnt].imagePathAddr != null) {
												tmpText = tmpText + "<img src='" + labelIconMap[cnt].imagePathAddr + "' alt='" + labelIconMap[cnt].altText + "' aria-hidden='true'>"
														+ "<p>" + labelIconMap[cnt].shortDesc + "</p>";
												if(labelIconMap[cnt].linkUrl != null && labelIconMap[cnt].linkUrl != '') {
													tmpText = tmpText + "</a>"
												}
												tmpText = tmpText + "</li>";
												tmpLabelAward = tmpLabelAward.replace(/\*shortDesc\*/g,tmpText);
												$labelList.append(tmpLabelAward);
											} else {
												tmpText = tmpText + "<p>" + labelIconMap[cnt].shortDesc + "</p>";
												if(labelIconMap[cnt].linkUrl != null && labelIconMap[cnt].linkUrl != '') {
													tmpText = tmpText + "</a>"
												}
												tmpText = tmpText + "</li>";
												tmpLabelFeature = tmpLabelFeature.replace(/\*shortDesc\*/g,tmpText);
												$labelList.append(tmpLabelFeature);
											}
										} else if(labelIconMap[cnt].shortDescType == 'DELIVERY') {
											tmpLabelDelivery = tmpLabelDelivery.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
											
											if(COUNTRY_CODE.toLowerCase()=='vn') {
												if('Y' == p.obsLeadTimeFlag && '' != p.obsLeadTimeMin && '' != p.obsLeadTimeMax) {
													tmpLabelDeliveryPeriod = tmpLabelDeliveryPeriod.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
													$labelList.append(tmpLabelDeliveryPeriod);
												} else {
													$labelList.append(tmpLabelDelivery);
												}
											} else if ( COUNTRY_CODE.toLowerCase()=='au' ) {
				                                var obsGroupCheck = ""; 
				                                obsGroupCheck = $('.navigation').attr('data-obs-group');
				                                if ( obsGroupCheck == "B2E" ) {
				                                } else {
				                                	tmpLabelDelivery = tmpLabelDelivery.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
				                                    $labelList.append(tmpLabelDelivery);
				                                    $labelList.find('.free-delivery').removeClass('d-none');
				                                }
											} else {
												$labelList.append(tmpLabelDelivery);									
											}
											
										} else if(labelIconMap[cnt].shortDescType == 'WARRANTY') {
											tmpLabelWarranty = tmpLabelWarranty.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
											$labelList.append(tmpLabelWarranty);
										} 
										  else if(labelIconMap[cnt].shortDescType == 'SHIPPINGFLAG') {
											tmpLabelShippingFlag = tmpLabelShippingFlag.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
											$labelList.append(tmpLabelShippingFlag);
										} else if(labelIconMap[cnt].shortDescType == 'DELIVERYFLAG') {
											tmpLabelDeliveryFlag = tmpLabelDeliveryFlag.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
											$labelList.append(tmpLabelDeliveryFlag);
										} else if(labelIconMap[cnt].shortDescType == 'INSTALLATIONFLAG') {
											tmpLabelInstallationFlag = tmpLabelInstallationFlag.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
											$labelList.append(tmpLabelInstallationFlag);
										}
										  else if(labelIconMap[cnt].shortDescType == 'BULLET') {
											tmpLabelBullet = tmpLabelBullet.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc);
											$labelList.append(tmpLabelBullet);
										}  else if(labelIconMap[cnt].shortDescType == 'KEYFEATUREFLAG') {
												if(labelIconMap[cnt].cssFontBold=="Y" && labelIconMap[cnt].cssFontItalic=="Y") {
													tmpText = "text-all";
												} else if(labelIconMap[cnt].cssFontBold=="Y") {
													tmpText = "text-bold";
												} else if(labelIconMap[cnt].cssFontItalic=="Y") {
													tmpText = "text-italic";
												} else {
													tmpText = "";
												}
												tmpLabelKeyfeatureFlag = tmpLabelKeyfeatureFlag.replace(/\*shortDesc\*/g,labelIconMap[cnt].shortDesc).replace(/\*cssFont\*/g,tmpText);
												$labelList.append(tmpLabelKeyfeatureFlag);
										}
										else {
										}
									}
								}
								var $tempThinqSignatureFlag = $template.find('.model-brand');
								var thinqFlag = $tempThinqSignatureFlag.find('template[data-thinqFlag]').clone().html();
								var signatureFlag = $tempThinqSignatureFlag.find('template[data-signatureFlag]').clone().html();
								if(p.signatureFlag == "Y") {
									$tempThinqSignatureFlag.append(signatureFlag+" ");
									ynBrandTag = "Y";
								}
								if(p.thinqFlag == "Y") {
									$tempThinqSignatureFlag.append(thinqFlag+" ");
									ynBrandTag = "Y";
								}
							}
							
							var $modelBuy = $template.find('.model-buy');
							var priceAreaTemplate = $modelBuy.find('template[data-template-type="priceArea"]').clone().html();
							var tmpPriceAreaTemplate = priceAreaTemplate;
							if((mode == 'selector' && (priceAreaYn != "N" || promotionAreaYn != "N") || mode != "selector")) {
								if(mode != 'selector') { // pupular
									if( emiMsgAreaYn == "Y" || (limitSaleUseFlag == "Y" && limitSaleAreaYn == "Y") ) {
										$modelBuy.addClass("has-topInfo");
									} else if ( p.membershipDisplayFlag == "Y") {
										$modelBuy.addClass("has-member");
									}
								} else {
									if( (emiMsgAreaYn == "Y" && emiUseFlag == "Y") || (limitSaleUseFlag == "Y" && limitSaleAreaYn == "Y") ) {
										$modelBuy.addClass("has-topInfo");
									} 
									if( priceAreaYn == "Y" && promotionAreaYn == "N" && limitSaleUseFlag != "Y" ) {
										$modelBuy.addClass("only-price");
									} else if ( priceAreaYn == "N" && promotionAreaYn == "Y" ) {
										$modelBuy.addClass("only-prm");
									}
								}

								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*afterPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;');
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*emiMsg\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '')
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*zipPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;') /* OBSLGEAU-749 (5000 -> 10000) */
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*orZipPay\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 3000) ? 'or ' : '')
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode) 
								var obsMemberShipLinkStartHtml = "";
								var obsMemberShipLinkEndHtml = "";
								if(p.obsMembershipLinkUrl != "" && p.obsMembershipLinkUrl != null && p.membershipDisplayFlag == 'Y'){
									obsMemberShipLinkStartHtml = "<a href='"+ p.obsMembershipLinkUrl +"' target='"+ p.obsMembershipLinkTarget +"' title='" +title+ "'>";
									obsMemberShipLinkEndHtml = "</a>"
								} 
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*obsMemberShipLinkStart\*/g,obsMemberShipLinkStartHtml);
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*obsMemberShipLinkEnd\*/g,obsMemberShipLinkEndHtml);
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*membershipDisplayFlag\*/g, p.membershipDisplayFlag)
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*membershipPrice\*/g, changeFormatFullPrice(p.rMembershipPrice, p.rMembershipPriceCent))
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*memberTextView\*/g, p.membershipDisplayFlag != 'Y' ? 'd-none' : '')
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*cheaperPriceFlag\*/g, p.cheaperPriceFlag) 
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*cheaperPrice\*/g, changeFormatFullPrice(p.cheaperPrice, p.cheaperPriceCent)) 
								tmpPriceAreaTemplate = tmpPriceAreaTemplate.replace(/\*cheaperTextView\*/g, p.cheaperPriceFlag == "Y" ? '' : 'd-none')
								;
								
								$modelBuy.append(tmpPriceAreaTemplate);
								/* LGCOMPA-44 start */
								if(  SIGN_IN_STATUS == 'N'
								  && !!p.membershipDisplayFlag
								  &&   p.membershipDisplayFlag == 'Y'
								  && !!productMessages.guestPriceMessageUseFlag
								  &&   productMessages.guestPriceMessageUseFlag == 'Y'
								  && !!productMessages.guestPriceMessage ){
									$modelBuy.find('.member-text').html('').append(productMessages.guestPriceMessage);
								}
								/* LGCOMPA-44 end */
							} else {
								$modelBuy.remove();
							}
							
							
							if(p.promotionLinkUrl) {
							} else {
								$template.find('.promotion-alchor-area').remove();
							}
							
							var opensTarget = $("#opensTarget").val();
							if(p.externalLinkTarget && p.externalLinkTarget=="New") {
								$template.find('.promotion-text a').attr('target', '_blank').attr('title', opensTarget);
							}
							
							if(mode != 'selector') {
								if(reStockFuncFlag == 'Y' || (limitSaleUseFlag == 'Y' && limitSaleAreaYn == 'Y')) {
								} else {
									$template.find('.stock-area').remove();
								}
								
								if(promotionAreaYn != "Y") {
									$template.find('.promotion-text').remove();
								}
								
								if(p.vipPriceFlag != 'Y') {
									$template.find('.price-vip-Installment').remove();
								}
							}
							
							// price setting
							var $priceArea = $template.find('.price-area.total');
							if($priceArea.length!=0) {
								$priceArea.removeClass('type-none type-default type-msrp type-promotion type-text');
								if(p.modelStatusCode=='DISCONTINUED') {
									// do nothing
								} else if(p.retailerPricingFlag == "Y") {
									// type text
									$priceArea.addClass('type-text');
									$priceArea.find('.text').text(p.retailerPricingText);
								} else if(p.rPromoPrice != null && p.rPrice != null && p.rPromoPrice != '' && p.rPrice != '') {
									// type promotion
									$priceArea.addClass('type-promotion');
									var price = changeFormatFullPrice(p.rPromoPrice, p.rPromoPriceCent);
									var pricePromo = changeFormatFullPrice(p.rPrice, p.rPriceCent);
									$priceArea.find('.purchase-price .price .number').text(price);
									$priceArea.find('.product-price .price .number').text(pricePromo);
									//[Start] LGEDE-1151 "has-uvp" 추가
			                        if($priceArea.find('.product-price .price.has-uvp').length>0) {
			                        	$priceArea.find('.product-price .price.has-uvp .number').text(pricePromo);
			                        };
			                        //[End] LGEDE-1151
									$priceArea.find('.product-price .legal').html(p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'));	
								} else {
									if(p.bizType=="B2B" && p.obsLoginFlag != "Y") { 
										if(p.rPrice != null && p.rPrice != '') {
											// type b2b
											var price1 = changeFormatFullPrice(p.rPrice, p.rPriceCent);
											$priceArea.addClass('type-msrp');
											$priceArea.find('.purchase-price .price .number').text(price1);
										}
									} else {
										if(p.rPrice != null && p.rPrice != '') {
											// type default
											var price2 = changeFormatFullPrice(p.rPrice, p.rPriceCent);
											$priceArea.addClass('type-default');
											$priceArea.find('.purchase-price .price .number').text(price2);
										}
									}
								}
								//PJTLIMITQTY_EXTEND
								var limitSaleConditionFlag =  p.vipPriceFlag == 'N' && p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y' ? 'Y' : 'N';
								if(p.vipPriceFlag == 'Y') {
									var priceOrg = changeFormatFullPrice(p.rPrice, p.rPriceCent);
									var pricePromo = changeFormatFullPrice(p.rPromoPrice, p.rPromoPriceCent);
									var legal = p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');		
									var vipPriceText = productMessages.vipPriceMessage;
									//LGEMS-432 Start
									if(COUNTRY_CODE.toLowerCase() == 'mx' && 'B2B' == $('.navigation').attr('data-obs-group')){
										vipPriceText = productMessages.b2bVipPriceMessage;
									}
									//LGEMS-432 End
									var previousPriceText = productMessages.previousPriceText;
									var emiMsgText = p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '';

									setVipPrice($priceArea, priceOrg, pricePromo, legal, vipPriceText, previousPriceText, p.modelId + '/' + 'category-filter.js',emiMsgText,p.afterPay, limitSaleConditionFlag, p.limitSaleTitle); // LGCOMMON-54
								}else if(SIGN_IN_STATUS == 'Y' && p.emiMemberMsg != null && p.emiMemberMsg != ''){
									setInstallmentMember($priceArea,p.emiMemberMsg);
								}
									if($priceArea.siblings( '.price-vip-Installment,.price-pdp-Installment').length > 0){
										$priceArea.removeClass('vip-price-area');	
									}
							}
							
			            	//LGCOMPL-218 start
							if ( p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice ) {
								if ( $template.find('.lowest-price-mark').length ) $template.find('.lowest-price-mark').removeClass('d-none');
								if ( $template.find('.lowest-price').length ) $template.find('.lowest-price').removeClass('d-none');
							} else {
								if ( $template.find('.lowest-price-mark').length ) $template.find('.lowest-price-mark').html('');
								if ( $template.find('.lowest-price').length ) $template.find('.lowest-price').html('');
							}
							//LGCOMPL-218 end
							
							// re stock alert
							var $stockArea = $template.find('.stock-area');
							if((!p.reStockAlertFlag || p.reStockAlertFlag!='Y') && $stockArea.length>0) {
								if( p.limitSaleUseFlag == 'Y' && p.obsLimitSale == 'Y'){
									if(p.obsInventoryFlag == 'Y'){
										$stockArea.removeClass('out-of-stock').empty();
									}else{
										$stockArea.find('.text').text(productMessages.limitSaleSoldOutText);
									}
								}else{
									$stockArea.removeClass('out-of-stock').empty();
								}
							}else{
								if(p.limitSaleUseFlag == 'Y' && p.obsLimitSale == 'Y'){
									$stockArea.find('.text').text(productMessages.limitSaleSoldOutText);
								}
							}

							// rolling image
							if(p.modelRollingImgList && p.modelRollingImgList != null) {
								$template.find('.visual img.pc').addClass('js-thumbnail-loop').attr('data-img-list', p.modelRollingImgList);
							}
							
							var $modelBtn = $template.find('.model-button');
							var btnAreaTemplate = $modelBtn.find('template[data-template-type="selectorBtnArea"]').clone().html();
							var tmpBtnAreaTemplate = btnAreaTemplate;
							
							if(btnAreaYn == 'Y') {
								var btnColorChange = ((obsLoginFlag == "T" || obsLoginFlag == "N") && buyNowUseFlag == "N" && p.addToCartFlag == "N" && p.resellerBtnFlag == "N" && p.buyNowFlag == "N" && p.productSupportFlag == "N" && p.obsPreOrderFlag == "N") ? "Y" : "N" 
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*modelId\*/g, p.modelId)
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*reStockAlertUrl\*/g, p.reStockAlertUrl ? p.reStockAlertUrl : "")
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*modelUrlPath\*/g, p.modelUrlPath)
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*whereToBuyUrl\*/g, p.whereToBuyUrl)
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*wtbClass\*/g,(p.wtbExternalLinkUseFlag =="Y" && p.wtbExternalLinkUrl != null && p.wtbExternalLinkUrl != '' && p.wtbExternalLinkName != null && p.wtbExternalLinkName != '') ? 'in-buynow' : 'where-to-buy')
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*obsPartnerUrl\*/g, nvl(p.obsPartnerUrl, ''))
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*inquiryToBuyUrl\*/g, p.inquiryToBuyUrl)
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*findTheDealerUrl\*/g, p.findTheDealerUrl)
								if ( obsBuynowFlag == "Y") {
									tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*btnInBuyNowView\*/g, btnColorChange == "Y" ? "btn-outline-secondary" : "btn-primary")
								} else {
									tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*btnAddToCartView\*/g, btnColorChange == "Y" ? "btn-outline-secondary" : "btn-primary")
								}
								tmpBtnAreaTemplate = tmpBtnAreaTemplate.replace(/\*btnWhereToBuyView\*/g, bizType == "B2C" ? btnColorChange == "Y" ? "btn-primary" : "btn-outline-secondary" : "")
								
								$modelBtn.prepend(tmpBtnAreaTemplate);
							} 
							// buttons
							if($template.find('.button a.re-stock-alert').length>0) {
								if((!p.reStockAlertFlag || p.reStockAlertFlag!='Y')) {
									$template.find('.button a.re-stock-alert').removeClass('active');
								} else {
									$template.find('.button a.re-stock-alert').addClass('active');
								}
							}
							if(p.obsPreOrderFlag == 'Y'){ //PJTOBS/2020/PJTOBSB2E-6 GILS
								if(p.obsBuynowFlag == 'Y'){
									if(p.preOrderTagEnableFlag == 'Y'){
										$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.modelUrlPath).text(productMessages.customOrderBtnNm).removeAttr('target, title')
										.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);	
									}else {
										$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.modelUrlPath).text(productMessages.preOrderBtnNm).removeAttr('target, title')
										.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);														
									}
								}else {
									if(p.preOrderTagEnableFlag == 'Y'){
										$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.customOrderBtnNm).attr('role', 'button').removeAttr('target, title')
										.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);
									}else {
										$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.preOrderBtnNm).attr('role', 'button').removeAttr('target, title')
										.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);
									}
								}
							}else if(p.addToCartFlag!="N") {
								if(p.addToCartFlag == 'Y') {
									if(p.obsBuynowFlag == 'Y'){
										// 통합 OBS
										var buynow = $('#buynow').val();
										$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.modelUrlPath).text(buynow).removeAttr('target, title');
									} else{
										// 통합 OBS
										$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
									}
								} else if(p.addToCartFlag == 'S') {
									// Standalone OBS
									$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
								}
							} else if(p.buyNowFlag=="Y" || p.buyNowFlag=="L") { // buyNowFlag==Y : book online 포함
								if(p.ecommerceTarget == '_blank') {
									$template.find('.button a.add-to-cart').addClass('active').addClass('in-buynow').data('model-id', p.modelId).attr('href', p.buyNowUrl).text(productMessages.buyNowBtnNm).removeAttr('role').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);//LGEGMC-1567
									if(p.addToCartFlag=="N"){
										$template.find('.button a.add-to-cart').data('link-name','buy_now').attr('data-link-name','buy_now');	
									}
								}else {
									$template.find('.button a.add-to-cart').addClass('active').addClass('in-buynow').data('model-id', p.modelId).attr('href', p.buyNowUrl).text(productMessages.buyNowBtnNm).removeAttr('role').removeAttr('target, title');//LGEGMC-1567
								}
							} else if (p.resellerBtnFlag=="Y") {
								$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.resellerLinkUrl).text(productMessages.resellerBtnNm).removeAttr('role').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);
							} else if (p.productSupportFlag=="Y") {
								$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.productSupportUrl).text(productMessages.productSupportBtnNm).removeAttr('role').removeAttr('target, title');
							} else {
								$template.find('.button a.add-to-cart').removeClass('active');
							}
							// WTB btn
							if(p.whereToBuyFlag=="Y" && p.whereToBuyUrl != null && p.whereToBuyUrl != '') {
								// go to pdp page
								$template.find('.button a.where-to-buy').addClass('active').attr('href', p.whereToBuyUrl).text(productMessages.whereToBuyBtnNm);
								$template.find('.button a.where-to-buy').removeAttr('target, title');
							} else if(p.wtbExternalLinkUseFlag=="Y" && p.wtbExternalLinkUrl != null && p.wtbExternalLinkUrl != '' && p.wtbExternalLinkName != null && p.wtbExternalLinkName != '') {
								// go to external link
								$template.find('.button a.in-buynow:not(.add-to-cart)').addClass('active').attr('href', p.wtbExternalLinkUrl).text(p.wtbExternalLinkName).attr('data-link-name', 'buy_now').removeAttr('data-sc-item');
								if(p.wtbExternalLinkSelfFlag == 'Y') {
									$template.find('.button a.in-buynow:not(.add-to-cart)').removeAttr('target, title');
								} else {
									$template.find('.button a.in-buynow:not(.add-to-cart)').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);
								}
							} else {
								$template.find('.button a.where-to-buy').removeClass('active');
							}
							// LGCOMPL-46 Start 
							if(p.obsSubscriptionEnableFlag != null && p.obsSubscriptionEnableFlag == 'Y') {
								$template.find('.button a.subscribe-box').removeClass('d-none');
							}
							// LGCOMPL-46 End
							if(p.buyNowUnionStoreBtnFlag =="Y"){
								$template.find('.button a.buyNowUnionBtn').addClass('active');
							} else{
								$template.find('.button a.buyNowUnionBtn').removeClass('active');
							}
							// Find a dealer btn
							if(p.findTheDealerFlag=="Y" && p.findTheDealerUrl != null && p.findTheDealerUrl != '') {
								$template.find('.button a.find-a-dealer').addClass('active').attr('href', p.findTheDealerUrl).text(productMessages.findTheDealerBtnNm);
							} else {
								$template.find('.button a.find-a-dealer').removeClass('active');
							}
							// inquiry to buy btn
							if(p.inquiryToBuyFlag=="Y" && p.inquiryToBuyUrl != null && p.inquiryToBuyUrl != '') {
								$template.find('.button a.inquiry-to-buy').addClass('active').attr('href', p.inquiryToBuyUrl).text(productMessages.inquiryToBuyBtnNm);
							} else {
								$template.find('.button a.inquiry-to-buy').removeClass('active');
							}
							
							$template.find('template').remove();
							if(i == 0){ // accessiblity focus item
								$template.addClass('first-item');
							}
							
							template = $template.get(0).outerHTML;
							html += template;
						}
						
						var template = html;
						var $template = $(template);
						var $modelButtonEl = $template.find('.products-info .model-button .button');
						$modelButtonEl.removeClass('only-button');
						$modelButtonEl.addClass('only-button');
						$modelButtonEl.each(function(){
							if($(this).find('a.active').length > 1){
								$modelButtonEl.removeClass('only-button');
							return;
							}
						});
						template = $template.get();
						html = template;
						if(mode == "selector") {
							screen.val.selectorPage = screen.val.selectorPage + modelList.length
						}
						
						 if (Number(screen.val.selectorPage) == Number(screen.val.totalCount)) {
							 if(!$('.selector-btn').hasClass('d-none')) {
								$('.selector-btn').addClass('d-none');
							}
						 }
					return html;
			     },
			     
			     // gpc_check HBS용 func (slick 관련 대상에 slick-initialized 클래스 추가)
			     gpc_check : function(){
			    	 var gpc4_check = $('.GPC0163 .GPC0004')
			    	 if(gpc4_check.length > 0){
			    		 if($('.GPC0163 .GPC0004 .unit-list').hasClass('slick-initialized') !== true){
			    			 $('.GPC0163 .GPC0004 .unit-list').slick(screen.val.strickOption)
						}	
					}
			     }
			},
			// 페이지 이벤트
			event : function () {
				// selector Option 변경
				$(".GPC0163 select[name='optionId']").on("change", function(e) {
					var param = {}; // ajax 통신용 파라미터
					var selectorIdx = Number($(this).attr("data-selector-idx")) // 셀렉터 Subject 인덱스 (idx)
					var nextSelectorIdx = selectorIdx + 1 // 셀렉터 Subject 다음 인덱스 (idx)
					var lastFlag =  $(this).attr('selector-lastSubject-flag') // 셀렉터 Subject 마지막 체크 플래그
					var $CTABtn = $(".selector-choice-btn").find(".btn-primary") // CTA 버튼
					
					screen.func.clearSelectorOption(selectorIdx); 
					
					if(isEmpty($(this).val())) { // 빈값인 경우
						screen.func.setSelectorOptionDisplay('default', '', '')
		    		} else { // 값이 있을 경우
	    				var imgUrl = !isEmpty($(this).find('option:selected').attr('data-selector-deskTopImgUrl')) ? $(this).find('option:selected').attr('data-selector-deskTopImgUrl') : $(this).find('option:selected').attr('data-selector-mobileImgUrl') 
	    				var imgDesc = $(this).find('option:selected').attr('data-selector-resultDesc')
	    				screen.func.setSelectorOptionDisplay('option', imgUrl, imgDesc);
	    				if(lastFlag == 'N') { // 마지막 옵션이 아닌경우
							// 파라미터 설정
	    					$CTABtn.prop('disabled', true);
							param.selectorId = $("input[name='selectorId']").val() // 셀렉터 값
				    		param.highLevelSelectorOptionId = $(this).find('option:selected').val() // 현재 선택한 옵션 값(통신시 상위 옵션)
				    		ajax.call($(".GPC0163").find("input[name='subjectOptionInfoUrl']").val(), xssfilter(param), 'json', function (d) { // ajax 통신
			    				var optionList = d.data[0].optionList;
			    				var $nextSubject = $("select[name='optionId'][data-selector-idx='"+nextSelectorIdx+"']")
			    				if(optionList.length > 0) { // optionList 값이 있을 경우만 
			    					for(var i=0; i < optionList.length; i++){
			    						var option = "";
			    						option = "<option value='"+optionList[i].selectorOptionId+"' data-selector-resultId='"+optionList[i].selectorResultId+"' data-selector-resultDesc='"+optionList[i].selectorOptionDesc+"' data-selector-deskTopImgUrl='"+optionList[i].selectorOptionDeskTopImgUrl+"' data-selector-mobileImgUrl='"+optionList[i].selectorOptionMobileImgUrl+"'>"+optionList[i].selectorOptionTitle+"</option>";
			    						$nextSubject.append(option);
			    					}
			    					$nextSubject.find("option:eq(0)").prop('selected',true);
			    					$nextSubject.trigger('chosen:updated');
			    				}
			    			}, 'post');
						} else { // 마지막 옵션이 경우
							if(isEmpty($(this).val())) {
								$CTABtn.prop('disabled', true);
							} else {
								$CTABtn.prop('disabled', false);
							}
						}
		    		}
				});
				
				// CTA 버튼 클릭
				$('.GPC0163 #selectorCTABtn').on('click', function(e) {
					var param = {};
					var popularHtml;
					var selectorHtml;
					var $CTAOption = $("select[name='optionId'][selector-lastSubject-flag='Y']").find('option:selected') // CTA 대상 옵션
					screen.val.selectorPage = 0; // 페이지 설정
		    		param.selectorResultId = $CTAOption.attr("data-selector-resultId") // selector ResultId
		    		param.categoryId = $("input[name='categoryId']").val() // 셀렉터 값
		    		param.startNo = 0; param.modelCnt = 3 // Limit 0, 3
		    		param.CTAFlag = 'Y'
			    	ajax.call($(".GPC0163").find("input[name='selectorResultInfoUrl']").val(), xssfilter(param), 'json', function (d) { // ajax 통신
			    		var selectorModelList = d.data[0].selectorModelList; // selector 모델리스트
			    		var popularList = d.data[0].popularList; // 추천 모델 리스트
			    		var productMessages = d.data[0].productMessages; // 제품 메세지
			    		var totalCount = d.data[0].totalResult
			    		screen.val.totalCount = d.data[0].totalResult
			    		$('#selectorAppendTarget').empty() // 기존 selector 모델리스트 제거
			    		$('#selectorPopularAppendTarget').empty() // 기존 추천 모델리스트 제거
			    		/* LGCOMPA-44 start */
			    		if(!!d.data[0].guestPriceMessageUseFlag && d.data[0].guestPriceMessageUseFlag == 'Y'){
			    			productMessages.guestPriceMessageUseFlag = d.data[0].guestPriceMessageUseFlag;
			    			productMessages.guestPriceMessage = d.data[0].guestPriceMessage;			    			
			    		}
			    		/* LGCOMPA-44 end */
			    		
			    		if(Number(totalCount) <= 3) { // 리스트 갯수 추가
							if(!$('.selector-btn').hasClass('d-none')) {
								$('.selector-btn').addClass('d-none');
							}
						} else {
							if($('.selector-btn').hasClass('d-none')) {
								$('.selector-btn').removeClass('d-none');
							}
						}
			    		if(selectorModelList.length > 0) { // 모델리스트 가 있을 경우
			    			if($('.selector-list-area').hasClass("d-none")) {
			    				$('.selector-list-area').removeClass('d-none');
			    			}
			    			selectorHtml = screen.func.setModelList(selectorModelList, productMessages, 'selector')
			    			$('#selectorAppendTarget').html(selectorHtml);
			    			var selectorTeargetDiv = document.getElementById('selectorAppedDivTarget');
				    		runBVStaticPLP($(selectorTeargetDiv)); // 리뷰항목 표시 (RV2용)
			    		}
			    		if(popularList.length > 0) { // 추천리스트가 있을 경우
			    			if($('.most-list').hasClass("d-none")) {
			    				$('.most-list').removeClass('d-none');
			    			}
			    			if($('.seeAll-model').hasClass("d-none")) {
			    				$('.seeAll-model').removeClass('d-none');
			    			}
			    			popularHtml = screen.func.setModelList(popularList, productMessages, 'popular')
			    			if($('.GPC0163 .GPC0004 .unit-list').is('.slick-initialized')) { // silck(JQuery) 처리 된 것 해제
			    				$('.GPC0163 .GPC0004 .unit-list').slick('unslick');
			    			}
			    			$('#selectorPopularAppendTarget').html(popularHtml);
			    			var popularAppendTargetDiv = document.getElementById('popularAppendTargetDiv');
				    		runBVStaticPLP($(popularAppendTargetDiv)); // 리뷰항목 표시 (RV2용)

			    			$('.GPC0163 .GPC0004 .unit-list').slick(screen.val.strickOption) // 조회한 내용으로 재 slick(JQuery) 처리
			    		}						
							
						/* LGETW-651 start */
						if(!!d.data[0].obsInstallmentPriceDisableLink && d.data[0].obsInstallmentPriceDisableLink == 'Y'){
							$('#selectorPopularAppendTarget').find('.price-installment').addClass('no-link').attr('tabindex','-1');
							$('#selectorAppedDivTarget').find('.price-installment').addClass('no-link').attr('tabindex','-1');
						}
						/* LGETW-651 end */
						
						// LGEDE-1231
						if(COUNTRY_CODE.toLowerCase()=='de' && ($(window).width() < 767 || isMobile) && document.querySelector('.selector-list-area')){
							let offsetTop = $('.GPC0163 .selector-list-area').offset().top;
							if(!!$('.GPC0151 .sticky-wrap').length){
								let outerHeight =  $('.GPC0151 .sticky-wrap').outerHeight();
								offsetTop = !!$('.GPC0151.sticky-active .sticky-wrap').length ? offsetTop - 55 : offsetTop - outerHeight - 55; //55 -> $('.GPC0151.sticky-active .sticky-wrap').outerHeight,
							}
							$(window).scrollTop(offsetTop-(20)); //20 -> padding
						}
						// LGEDE-1231 End
		 			}, 'post');
		    	});
				
				// loadMore 버튼 클릭
		    	$('.GPC0163 #selectorLoadMoreBtn').on('click', function(e) {
		    		var selectorHtml;
		    		var $CTAOption = $("select[name='optionId'][selector-lastSubject-flag='Y']").find('option:selected')
		    		var param = {};
		    		param.selectorResultId = $CTAOption.attr("data-selector-resultId")
		    		param.startNo = screen.val.selectorPage
		    		param.modelCnt = "9"
		    		param.CTAFlag = 'N'
		    		ajax.call($(".GPC0163").find("input[name='selectorResultInfoUrl']").val(), xssfilter(param), 'json', function (d) {
		    			var selectorModelList = d.data[0].selectorModelList;
		    			var productMessages = d.data[0].productMessages;
		    			/* LGCOMPA-44 start */
			    		if(!!d.data[0].guestPriceMessageUseFlag && d.data[0].guestPriceMessageUseFlag == 'Y'){
			    			productMessages.guestPriceMessageUseFlag = d.data[0].guestPriceMessageUseFlag;
			    			productMessages.guestPriceMessage = d.data[0].guestPriceMessage;			    			
			    		}
			    		/* LGCOMPA-44 end */
		    			selectorHtml = screen.func.setModelList(selectorModelList, productMessages, 'selector');
		    			$('#selectorAppendTarget').append(selectorHtml);
							
						/* LGETW-651 start */
						if(!!d.data[0].obsInstallmentPriceDisableLink && d.data[0].obsInstallmentPriceDisableLink == 'Y'){
							$('#selectorAppendTarget').find('.price-installment').addClass('no-link').attr('tabindex','-1');							
						}
						/* LGETW-651 end */	
		    			var selectorTeargetDiv = document.getElementById('selectorAppedDivTarget');
			    		runBVStaticPLP($(selectorTeargetDiv)); // 리뷰항목 표시 (RV2용)
		    		}, 'post');
		    	});
		    	
		    	$('.GPC0163 .label-list button').on('click', function(){
		    		$(this).parents('.label-list').find('.label-inner').toggleClass("imp");
		    	});
			},
			// 페이지 초기화 함수
			init : function () {
		    	$(".selector-choice-view").find(".default").removeClass("d-none")
		    	$(".selector-choice-view").find(".view-act").addClass("d-none")
				$('#selectorResultTemplate').remove();
				$('#selectorPopularTemplate').remove();
				screen.func.gpc_check();
				screen.event();
			}
	}
	screen.init(); // 페이지 초기화

	// 페이지 전역 함수 영역 
	function nvl(str, defaultStr){
		var check = str+"";
		var result = "";
		check = check.trim()
		if(check=="" || check==null || check == "null" || check=="undefined"){
			result = defaultStr;
		}else{
			result = check;
		}
		return result ;
	}
	
	// isEmpty 체크
	function isEmpty (val) {
		if( val == "" || val == null || val == undefined || val == "null" || val == "undefined"){
			return true
		}else{
			return false
		}
	}
});
